import React, {useEffect, useState} from 'react';
import OrderProductsList from './OrderProductsList';
import {Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';
import Translate from '@src/components/Translate/Translate';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import getUri from '@src/helpers/getUri';
import usePermissionGranted from '@src/hooks/usePermissionGranted';
import {shortCode} from '@src/helpers/hash/shortCode';
import OrderOperationsList from '@views/dashboard/production/OrderOperationsList/Body';

export const GET_PARAM_NAME = shortCode('Dashboards:Production.tabs');

export default function Body() {
    const keys = [
        'Dashboards:Production.tabs.order-products',
        'Dashboards:Production.tabs.order-operations',
    ] as const;

    const location = useLocation();
    const navigate = useNavigate();
    const locationTab = decodeURIComponent(
            new URLSearchParams(location.search).get(GET_PARAM_NAME) ?? ''
    );
    const [loadedTabs, setLoadedTabs] = useState<Record<string, true>>({});
    const canDisplayOperationsOnThisPage = usePermissionGranted(
            'orders@can-edit-product-operations-workers'
    );

    const activeTab = locationTab && keys.includes(locationTab as any) ? locationTab : keys[0];

    useEffect(() => {
        setLoadedTabs(map => {
            if (activeTab in map) {
                return map;
            }

            return ({...map, [activeTab]: true});
        });
    }, [activeTab]);

    return <>
        <Nav className="nav-tabs-custom" tabs>
            {keys.map(name => {
                if (!canDisplayOperationsOnThisPage && name === 'Dashboards:Production.tabs.order-operations') {
                    return <NavItem key={`ProductionDashboard-${name}-tab-control-link`}>
                        <NavLink
                                tag={Link}
                                active={false}
                                to={getUri('dashboards@production-operations-list')}
                        >
                            <Translate message="Dashboards:Production.tabs.order-operations"/>
                            <span className="text-muted small ms-2">
                                <i className="fas fa-up-right-from-square"/>
                            </span>
                        </NavLink>
                    </NavItem>;
                }

                return <NavItem key={`ProductionDashboard-${name}-tab-control`}>
                    <NavLink
                            href={`#${name}`}
                            active={activeTab === name}
                            onClick={e => {
                                e.preventDefault();

                                const search = new URLSearchParams(location.search);
                                search.set(GET_PARAM_NAME, name);

                                navigate({
                                    ...location,
                                    search: search.toString(),
                                }, {replace: true});
                            }}
                    >
                        <Translate message={name}/>
                    </NavLink>
                </NavItem>;
            })}
        </Nav>

        <TabContent activeTab={activeTab} className="py-3">
            {keys.map(name => {
                if (!(name in loadedTabs)) {
                    return null;
                }

                return <TabPane tabId={name} key={`ProductionDashboard-${name}-tab-pane`}>
                    {
                        name === 'Dashboards:Production.tabs.order-products' ?
                                <OrderProductsList/> :
                                null
                    }

                    {
                        name === 'Dashboards:Production.tabs.order-operations' ?
                                <OrderOperationsList hideSchedule/> :
                                null
                    }
                </TabPane>;
            })}
        </TabContent>
    </>;
}
